export default __webpack_public_path__ + "static/media/attendance.24be406e.svg";